//#region packages/@mantine/core/src/core/factory/create-polymorphic-component.ts
function createPolymorphicComponent(component) {
	return component;
}
const polymorphic = createPolymorphicComponent;
//#endregion
export { createPolymorphicComponent, polymorphic };

//# sourceMappingURL=create-polymorphic-component.mjs.map